const WRAPPER_SELECTOR = '.b3rg-posts--customers';
const LIST_SELECTOR = '.customer-list';
const CARD_SELECTOR = '.e-sgp--customer';

/**
 * FacetWP "Load more" appends each page as a new wrapper;
 * move the new cards into the first list so they share one grid.
 */
const mergeLists = () => {
  document.querySelectorAll( '.facetwp-template' ).forEach( ( template ) => {
    const wrappers = template.querySelectorAll( WRAPPER_SELECTOR );
    if ( wrappers.length < 2 ) return;

    const mainList = wrappers[0].querySelector( LIST_SELECTOR );
    Array.from( wrappers ).slice( 1 ).forEach( ( wrapper ) => {
      const list = wrapper.querySelector( LIST_SELECTOR );
      if ( list && mainList ) {
        while ( list.firstElementChild ) mainList.appendChild( list.firstElementChild );
      }
      wrapper.remove();
    } );
  } );
};

/**
 * Masonry: span each column over as many 1px grid rows as its card is tall.
 */
const layoutList = ( list ) => {
  const columnCount = window.getComputedStyle( list ).gridTemplateColumns.split( ' ' ).length;

  Array.from( list.children ).forEach( ( column ) => {
    const card = column.querySelector( CARD_SELECTOR );
    if ( !card ) return;
    if ( columnCount < 2 ) {
      column.style.gridRowEnd = '';
      return;
    }
    const paddingBottom = parseFloat( window.getComputedStyle( column ).paddingBottom ) || 0;
    column.style.gridRowEnd = `span ${Math.ceil( card.offsetHeight + paddingBottom )}`;
  } );
};

const layoutAll = () => {
  document.querySelectorAll( `${WRAPPER_SELECTOR} ${LIST_SELECTOR}` ).forEach( layoutList );
};

const bindImageLoad = () => {
  document.querySelectorAll( `${WRAPPER_SELECTOR} img` ).forEach( ( img ) => {
    if ( img.complete || img.dataset.masonryBound === '1' ) return;
    img.dataset.masonryBound = '1';
    img.addEventListener( 'load', layoutAll, { once: true } );
  } );
};

const init = () => {
  if ( !document.querySelector( WRAPPER_SELECTOR ) ) return;
  mergeLists();
  layoutAll();
  bindImageLoad();
};

const customersListing = () => {
  let resizeTimer;

  document.addEventListener( 'DOMContentLoaded', init );
  document.addEventListener( 'facetwp-loaded', init );
  window.addEventListener( 'load', layoutAll );
  window.addEventListener( 'resize', () => {
    clearTimeout( resizeTimer );
    resizeTimer = setTimeout( layoutAll, 150 );
  } );
};

customersListing();
